import React, { useEffect, useState } from "react";
import "./SearchHistory.css";
import Search from "../../../components/Search";
import api from "../../../services/baseUrl";
import download from "downloadjs";
import { useWarta } from "../../../context/WartaContext";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Cookies from "js-cookie";


export default function SearchHistory() {
  const [data, setData] = useState([]);
  const userId = JSON.parse(Cookies.get("wartaUser")).userId;
  const { setCartData } = useWarta();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.get("/ewarta/requests/get", {
          params: {
            userId,
          },
        });
        const sortedData = response.data.sort(
          (a, b) => new Date(b.dateCreated) - new Date(a.dateCreated)
        );
        setData(sortedData);
      } catch (e) {}
    };
    fetchData();
  }, [userId]);

  const addToCart = async (item) => {
    try {
      const response = await api.post("/ewarta/cart/add", {
        userId: item.userId.userId,
        wartaDocumentId: item.wartaDocumentId,
      });

      if (response.status === 201) {
        loadCart(response.data.userId);
        toast.success("Added to cart successfully!");
      }
    } catch (error) {
      if (error.response && error.response.status === 409) {
        toast.warning("Document already added to cart.");
      } else {
        console.error("An error occurred while adding to cart:", error);
        // Optionally handle other errors
      }
    }
  };

  const loadCart = async (data) => {
    const response = await api.post("/ewarta/cart/get", {
      userId: data,
    });

    if (response.status === 200) {
      setCartData(response.data);
    }
  };

  const downloadPdf = async (requestId) => {
    try {
      const response = await api.post(
        "ewarta/request/get",
        { requestId },
        {
          headers: {
            "Content-Type": "application/json",
          },
          responseType: "blob",
        }
      );

      const fileName = "Lawnet Warta On Demand";

      const contentType = response.headers["content-type"];
      download(response.data, fileName.split("/").pop(), contentType);
    } catch (error) {
      console.error("Error downloading the PDF:", error);
    }
  };
  return (
    <div className="search-history-container">
      <div className="search-history-announcement">
        Here, you can review your past requests, searches, and interactions with
        gazettes, and easily access any previously viewed or downloaded gazettes
      </div>
      <div className="search-history-searchbox">
        <Search />
      </div>
      <div className="search-history-body">
        <div className="ewarta-search-result-body">
          <table style={{ padding: "25px" }}>
            <thead>
              <tr>
                <td>Request Id</td>
                <td>Date & Time</td>
                <td>Search Title</td>
                <td>Result Summary</td>
              </tr>
            </thead>
            <tbody>
              {data.map((item) => {
                const queryParts = item.query.split(" | ");

                const isSingleValue = queryParts.every(
                  (part) => !part.includes(":")
                );

                return (
                  <tr key={item.id}>
                    <td>{item.id}</td>
                    <td>
                      {new Date(item.dateCreated).toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                      })}
                    </td>
                    <td style={{ textAlign: "left" }}>
                      {isSingleValue ? (
                        // If it's just a single value, display as one <li>
                        <ul style={{ padding: 0, listStyleType: "none" }}>
                          <li>{item.query}</li>
                        </ul>
                      ) : (
                        // If there are key-value pairs, display as an ordered list
                        <ul style={{ padding: 0, listStyleType: "none" }}>
                          {queryParts.map((part, index) => {
                            const [key, value] = part.split(": ");

                            // Function to convert camelCase to Title Case
                            const formatKey = (key) => {
                              return key
                                .replace(/([A-Z])/g, " $1") // insert space before capital letters
                                .replace(/^./, (str) => str.toUpperCase()); // capitalize first letter
                            };

                            return (
                              <li key={index}>
                                <strong>{key ? formatKey(key) : ""}:</strong>{" "}
                                {value}
                              </li>
                            );
                          })}
                        </ul>
                      )}
                    </td>
                    <td>
                      {item.status === null || item.status === 0 ? (
                        <>
                          {" "}
                          Please wait, our admin is for searching your document
                        </>
                      ) : item.status === 1 ? (
                        <>
                          Document has been found. Click&nbsp;
                          <span
                            onClick={() => addToCart(item)}
                            style={{ color: "blue", cursor: "pointer" }}
                          >
                            here
                          </span>{" "}
                          to add to cart.
                        </>
                      ) : item.status === 2 ? (
                        <>
                          Document has been purchased. Click&nbsp;
                          <span
                            onClick={() => downloadPdf(item.wartaDocumentId)}
                            style={{ color: "blue", cursor: "pointer" }}
                          >
                            here
                          </span>{" "}
                          to download.
                        </>
                      ) : (
                        <>Unknown status</>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          <div style={{ height: "30px" }}></div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
}
